var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function createLock() {
    let isLocking = false;
    return function (_target, _key, desc) {
        const originFn = desc.value;
        if (typeof originFn !== 'function') {
            throw new Error('createLock must be used in method!');
        }
        desc.value = function () {
            return __awaiter(this, arguments, void 0, function* () {
                try {
                    if (isLocking) {
                        return;
                    }
                    isLocking = true;
                    const res = yield originFn.apply(this, arguments);
                    return res;
                }
                catch (error) {
                    throw error;
                }
                finally {
                    isLocking = false;
                }
            });
        };
        return desc;
    };
}
export function checkLogin(_target, _key, desc) {
    const originFn = desc.value;
    if (typeof originFn !== 'function') {
        throw new Error('checkLogin must be used in method!');
    }
    desc.value = function () {
        return __awaiter(this, arguments, void 0, function* () {
            const isLogin = txv.login.isLogin();
            // console.log('islogin', isLogin)
            if (isLogin) {
                const res = yield originFn.apply(this, arguments);
                return res;
            }
            txv.login.openLogin();
            throw new Error('check login: not login');
        });
    };
}
